import React from 'react'
import {UniLink} from '../unilink/index'
import {setCookie} from '../../../util/cookies'
import FollowLinks from './FollowLinks'
import './footer.css'


const Footer = () => {
  return (
    <footer className='expii-footer'>
      <div className='footer gridcontainer'>
        <div className='links'>
          <div className='about-links'>
            <h6>ABOUT US</h6>
            <UniLink to='/about'>About</UniLink>
            <UniLink to='/about/jobs'>Jobs</UniLink>
            <UniLink to='/about/contact'>Contact</UniLink>
          </div>
          <div className='explore-links'>
            <h6>EXPLORE</h6>
            <UniLink href='https://daily.poshenloh.com'>Daily Challenge</UniLink>
            <UniLink to='/solve' target="_self">Solve</UniLink> {/* Need to have target="_self" to jump out of React Single Page App, because the /solve path is served by the v1 client, which the server routes to directly */}
            <UniLink href='https://zoom.poshenloh.com/'>Moderate Zoom Chat</UniLink>
            <UniLink href='https://live.poshenloh.com/'>Live Math Courses</UniLink> 
          </div>
          <div className='explore-links'>
            <h6>INITIATIVES</h6>
            <UniLink to='/spark'>Spark</UniLink>
            <UniLink to='/ramanujan'>Ramanujan</UniLink>
            <UniLink to='/NYAS'>Showcase</UniLink>
          </div>
          <div className='info-links'>
            <h6>INFO</h6>
            <UniLink className='terms' to='/terms'>Terms of Service</UniLink>
            <UniLink className='conduct' to='/conduct'>Code of Conduct</UniLink>
            <UniLink to='/privacy'>Privacy Notice</UniLink>
            <UniLink href='https://lca.expii.com/'>Labor Condition Applications</UniLink>
          </div>
        </div>
        <div className='other-info'>
          <div className='social-media-links'>
            <FollowLinks linkStyle='icons' />
          </div>
          <div className='copyright'>
            &copy; 2019 Expii, Inc.
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer



// WEBPACK FOOTER //
// ./src/core/components/footer/Footer.js